import { Component, Input, OnInit } from '@angular/core';
import { ApplicationRouterService } from 'src/app/@core/application-router/application-router.service';
import { RouteExecutor } from 'src/app/@core/application-router/route.executor';
import { HyperLinkData } from 'src/app/generic-page/generic-page.data';
import { UserMemberShipData } from '../account-page.data';
import { AccountPageService } from '../account-page.service';

@Component({
    selector: 'app-user-membership-page',
    templateUrl: './user-membership-page.component.html',
    styleUrls: ['./user-membership-page.component.scss'],
})
export class UserMembershipPageComponent
    extends RouteExecutor
    implements OnInit
{
    @Input() data: UserMemberShipData | any;
    constructor(
        private accountPageService: AccountPageService,
        applicationRouterService: ApplicationRouterService
    ) {
        super(applicationRouterService);
        console.log('user-membership');
    }

    ngOnInit(): void {
        this.accountPageService.getProfileObs().subscribe(profile => {
            console.log('user-membership', profile);
            this.data = profile;
        });
    }
}
